module.exports = __webpack_public_path__ + "static/img/logo_074.fe41c64b.png";